export enum WellKnownAuthErrors {
    NoMatchingState = 'No matching state found in storage',
    IFrameTimeout = 'IFrame timed out without a response',
    InvalidGrant = 'invalid_grant',
    LoginRequired = 'login_required',
    FailedToFetch = 'Failed to fetch',
}

export type ErrorFn = (error: unknown) => void;

export const defaultErrorHandler: ErrorFn = (error: unknown) => {
    const authErrorRoute = `${window.location.origin}/portal_/autherror`;

    if (error instanceof Error) {
        window.location.assign(`${authErrorRoute}?error=${error.message}`);
        return;
    }

    window.location.assign(authErrorRoute);
};
